import { MaskedInput } from '@qga/roo-ui/components';
import { phoneMask } from 'lib/inputMasks';

const PhoneInput = (props) => <MaskedInput mask={phoneMask} type="tel" {...props} />;

export default PhoneInput;
